import { AerovaleDetalle } from "@shared/models/despacho/AerovaleDetalle";
import { Usuario } from "@shared/models/despacho/Usuario";

export class AerovaleAnulacionReemplazoDTO {
    aerovaleDetalle: AerovaleDetalle;
    comentario: string;
    observacion: string;
    usuarioDto: Usuario;
}